import './App.css';
import { useState, useEffect } from 'react';
import Renderer from "./Renderer";

function App() {
  const [data, setData] = useState([


   {
        "id": 66,
        "element": "title",
        "position": 0,
        "text": "VALIDA",
        "font": null,
        "align": "center",
        "width": null,
        "table_cols": null,
        "col_1_width": null,
        "col_2_width": null,
        "col_3_width": null,
        "col_4_width": null,
        "col_5_width": null,
        "image": null,
        "rows": [],
        "noEdit": true
    },
    {
        "id": 67,
        "element": "image",
        "position": 1,
        "text": null,
        "font": null,
        "align": "center",
        "width": null,
        "table_cols": null,
        "col_1_width": null,
        "col_2_width": null,
        "col_3_width": null,
        "col_4_width": null,
        "col_5_width": null,
        "image": {
            "id": 205,
            "name": "valida-bg-lg-sSM6sN.webp",
            "bucket": "202506",
            "width": 1520,
            "height": 764,
            "type": "image/png",
            "orig": "valida-bg-lg-sSM6sN-orig.png"
        },
        "rows": [],
        "noEdit": true
    },
    {
        "id": 68,
        "element": "text",
        "position": 2,
        "text": "VALIDA wrapper is our premium packaging machine for hygienic and kitchen rolls. It is a robust wrapper designed for mass production of tissue rolls, for packs from a single roll up to 48 rolls on a single or double layer, with 4 (optionally 5) lanes infeed. This wrapper is easy to use, it is fully servo driven, entirely controlled by 24 servomotors and by the most advanced motion controllers which allow highest flexibility and extremely fast format changeover. \r\n\r\nWith a production speed that exceeds 200 packs/minute and extremely easy maintenance, VALIDA places itself as the most advanced and at the same time the most efficient wrapper on the market.",
        "font": 11,
        "align": null,
        "width": null,
        "table_cols": null,
        "col_1_width": null,
        "col_2_width": null,
        "col_3_width": null,
        "col_4_width": null,
        "col_5_width": null,
        "image": null,
        "rows": [],
        "noEdit": true
    },
    {
        "id": 69,
        "element": "table",
        "position": 3,
        "text": "Tabela",
        "font": null,
        "align": "center",
        "width": null,
        "table_cols": 5,
        "col_1_width": null,
        "col_2_width": null,
        "col_3_width": null,
        "col_4_width": null,
        "col_5_width": null,
        "image": null,
        "rows": [
            {
                "id": 29,
                "field_1": "Marko",
                "field_2": null,
                "field_3": null,
                "field_4": null,
                "field_5": null,
                "field_1_image_id": null,
                "field_2_image_id": null,
                "field_3_image_id": null,
                "field_4_image_id": null,
                "field_5_image_id": null,
                "image_1": null,
                "image_2": null,
                "image_3": null,
                "image_4": null,
                "image_5": null
            },
            {
                "id": 30,
                "field_1": null,
                "field_2": null,
                "field_3": null,
                "field_4": null,
                "field_5": null,
                "field_1_image_id": null,
                "field_2_image_id": null,
                "field_3_image_id": null,
                "field_4_image_id": null,
                "field_5_image_id": null,
                "image_1": null,
                "image_2": null,
                "image_3": null,
                "image_4": null,
                "image_5": null
            },
            {
                "id": 31,
                "field_1": null,
                "field_2": null,
                "field_3": null,
                "field_4": null,
                "field_5": null,
                "field_1_image_id": null,
                "field_2_image_id": null,
                "field_3_image_id": null,
                "field_4_image_id": null,
                "field_5_image_id": null,
                "image_1": null,
                "image_2": null,
                "image_3": null,
                "image_4": null,
                "image_5": null
            }
        ],
        "noEdit": true
    },
    {
        "id": 70,
        "element": "text",
        "position": 4,
        "text": "VALIDA In stock VALIDA wrapper is our premium packaging machine for hygienic and kitchen rolls. It is a robust wrapper designed for mass production of tissue rolls, for packs from a single roll up to 48 rolls on a single or double layer, with 4 (optionally 5) lanes infeed. This wrapper is easy to use, it is fully servo driven, entirely controlled by 24 servomotors and by the most advanced motion controllers which allow highest flexibility and extremely fast format changeover. With a production speed that exceeds 200 packs/minute and extremely easy maintenance, VALIDA places itself as the most advanced and at the same time the most efficient wrapper on the market.",
        "font": null,
        "align": null,
        "width": null,
        "table_cols": null,
        "col_1_width": null,
        "col_2_width": null,
        "col_3_width": null,
        "col_4_width": null,
        "col_5_width": null,
        "image": null,
        "rows": [],
        "noEdit": true
    },
    {
        "id": 74,
        "element": "new page",
        "position": 5,
        "text": null,
        "font": null,
        "align": null,
        "width": null,
        "table_cols": null,
        "col_1_width": null,
        "col_2_width": null,
        "col_3_width": null,
        "col_4_width": null,
        "col_5_width": null,
        "image": null,
        "rows": [],
        "noEdit": true
    },
    {
        "id": 76,
        "element": "image",
        "position": 6,
        "text": null,
        "font": null,
        "align": "center",
        "width": 90,
        "table_cols": null,
        "col_1_width": null,
        "col_2_width": null,
        "col_3_width": null,
        "col_4_width": null,
        "col_5_width": null,
        "image": {
            "id": 207,
            "name": "spec2-ZEm0pp.webp",
            "bucket": "202506",
            "width": 619,
            "height": 677,
            "type": "image/jpeg",
            "orig": "spec2-ZEm0pp-orig.jpeg"
        },
        "rows": [],
        "noEdit": true
    },
    {
        "id": 77,
        "element": "text",
        "position": 7,
        "text": "VALIDA In stock VALIDA wrapper is our premium packaging machine for hygienic and kitchen rolls. It is a robust wrapper designed for mass production of tissue rolls, for packs from a single roll up to 48 rolls on a single or double layer, with 4 (optionally 5) lanes infeed. This wrapper is easy to use, it is fully servo driven, entirely controlled by 24 servomotors and by the most advanced motion controllers which allow highest flexibility and extremely fast format changeover. With a production speed that exceeds 200 packs/minute and extremely easy maintenance, VALIDA places itself as the most advanced and at the same time the most efficient wrapper on the market.",
        "font": 11,
        "align": null,
        "width": null,
        "table_cols": null,
        "col_1_width": null,
        "col_2_width": null,
        "col_3_width": null,
        "col_4_width": null,
        "col_5_width": null,
        "image": null,
        "rows": [],
        "noEdit": true
    },
    {
        "id": 78,
        "element": "new page",
        "position": 8,
        "text": null,
        "font": null,
        "align": null,
        "width": null,
        "table_cols": null,
        "col_1_width": null,
        "col_2_width": null,
        "col_3_width": null,
        "col_4_width": null,
        "col_5_width": null,
        "image": null,
        "rows": [],
        "noEdit": true
    },
    {
        "id": 79,
        "element": "title",
        "position": 9,
        "text": "Tabela",
        "font": null,
        "align": "center",
        "width": null,
        "table_cols": null,
        "col_1_width": null,
        "col_2_width": null,
        "col_3_width": null,
        "col_4_width": null,
        "col_5_width": null,
        "image": null,
        "rows": [],
        "noEdit": true
    },
    {
        "id": 80,
        "element": "image",
        "position": 10,
        "text": null,
        "font": null,
        "align": "center",
        "width": null,
        "table_cols": null,
        "col_1_width": null,
        "col_2_width": null,
        "col_3_width": null,
        "col_4_width": null,
        "col_5_width": null,
        "image": {
            "id": 207,
            "name": "spec2-ZEm0pp.webp",
            "bucket": "202506",
            "width": 619,
            "height": 677,
            "type": "image/jpeg",
            "orig": "spec2-ZEm0pp-orig.jpeg"
        },
        "rows": [],
        "noEdit": true
    },
    {
        "id": 60,
        "element": "title",
        "position": 0,
        "text": "TITLE",
        "font": null,
        "align": "center",
        "width": null,
        "table_cols": null,
        "col_1_width": null,
        "col_2_width": null,
        "col_3_width": null,
        "col_4_width": null,
        "col_5_width": null,
        "image": null,
        "rows": [],
        "noEdit": true
    },
    {
        "id": 59,
        "element": "title",
        "position": 2,
        "text": "TITLE",
        "font": null,
        "align": "center",
        "width": null,
        "table_cols": null,
        "col_1_width": null,
        "col_2_width": null,
        "col_3_width": null,
        "col_4_width": null,
        "col_5_width": null,
        "image": null,
        "rows": [],
        "noEdit": true
    },
    {
        "id": 58,
        "element": "title",
        "position": 3,
        "text": "TITLE",
        "font": null,
        "align": "center",
        "width": null,
        "table_cols": null,
        "col_1_width": null,
        "col_2_width": null,
        "col_3_width": null,
        "col_4_width": null,
        "col_5_width": null,
        "image": null,
        "rows": [],
        "noEdit": true
    },
    {
        "id": "new-line-first",
        "element": "new page"
    },
    
    {
        "id": "table-0",
        "element": "table",
        "noEdit": true,
        "text": "COMPLETE PROJECT PRICES",
        "table_cols": 5,
        "col_1_width": 6,
        "col_2_width": 51,
        "col_3_width": 7,
        "col_4_width": 18,
        "col_5_width": 18,
        "rows": [
            {
                "id": "item-0",
                "field_1": "No.",
                "field_2": "Description",
                "field_3": "Qty",
                "field_4": "Unit price",
                "field_5": "Total price"
            },
            {
                "id": "item-12",
                "field_1": 1,
                "field_2": "VALIDA LH (Omron)",
                "field_3": 1,
                "field_4": "700.000 €",
                "field_5": "700.000 €"
            },
            {
                "id": "item-option-93",
                "field_1": "1.1",
                "field_2": "Electrical Cabinet Cooling System: AC Device",
                "field_3": 1,
                "field_4": "",
                "field_5": ""
            },
            {
                "id": "item-option-94",
                "field_1": "1.2",
                "field_2": "Power Supply: 3P/N/PE_400/230Vac_50/60Hz",
                "field_3": 1,
                "field_4": "",
                "field_5": ""
            },
            {
                "id": "item-option-96",
                "field_1": "1.3",
                "field_2": "Pack configurations",
                "field_3": 1,
                "field_4": "",
                "field_5": ""
            },
            {
                "id": "item-option-97",
                "field_1": "1.4",
                "field_2": "Wrapping System Poly: Polyethylene Wrap",
                "field_3": 1,
                "field_4": "",
                "field_5": ""
            },
            {
                "id": "item-option-98",
                "field_1": "1.5",
                "field_2": "Poly Unwind System: Rollers",
                "field_3": 1,
                "field_4": "",
                "field_5": ""
            },
            {
                "id": "item-option-99",
                "field_1": "1.6",
                "field_2": "Format Change-Over: Hand Wheels & Cranks",
                "field_3": 1,
                "field_4": "",
                "field_5": ""
            },
            {
                "id": "item-option-100",
                "field_1": "1.7",
                "field_2": "Handle Applicator (reel inside)",
                "field_3": 1,
                "field_4": "",
                "field_5": ""
            },
            {
                "id": "item-option-115",
                "field_1": "1.8",
                "field_2": "Handle Applicator (reel outside) with auto-spicer",
                "field_3": 1,
                "field_4": "",
                "field_5": ""
            },
            {
                "id": "item-14",
                "field_1": 2,
                "field_2": "STELLA (Omron)",
                "field_3": 1,
                "field_4": "",
                "field_5": ""
            },
            {
                "id": "item-option-104",
                "field_1": "2.1",
                "field_2": "Power Supply: 3P/N/PE_400/230Vac_50/60Hz",
                "field_3": 1,
                "field_4": "",
                "field_5": ""
            },
            {
                "id": "item-option-105",
                "field_1": "2.2",
                "field_2": "Changing set of tools for pack width dimension",
                "field_3": 1,
                "field_4": "",
                "field_5": ""
            },
            {
                "id": "item-option-106",
                "field_1": "2.3",
                "field_2": "Changing set of tools for pack height dimension (2 pieces in set!)",
                "field_3": 1,
                "field_4": "",
                "field_5": ""
            },
            {
                "id": "item-option-107",
                "field_1": "2.4",
                "field_2": "Wrapping System Poly: Polyethylene Wrap",
                "field_3": 1,
                "field_4": "",
                "field_5": ""
            },
            {
                "id": "item-option-108",
                "field_1": "2.5",
                "field_2": "Format Change-Over: Hand Wheels & Cranks",
                "field_3": 1,
                "field_4": "",
                "field_5": ""
            },
            {
                "id": "item-option-109",
                "field_1": "2.6",
                "field_2": "Machine preparation for the height of pack up to 160 mm",
                "field_3": 1,
                "field_4": "",
                "field_5": ""
            },
            {
                "id": "item-option-110",
                "field_1": "2.7",
                "field_2": "Laminated paper wrapping",
                "field_3": 1,
                "field_4": "",
                "field_5": ""
            },
            {
                "id": "item-15",
                "field_1": 3,
                "field_2": "Instalations",
                "field_3": 1,
                "field_4": "",
                "field_5": ""
            },
            {
                "id": "item-option-111",
                "field_1": "3.1",
                "field_2": "Standard toolbox",
                "field_3": 1,
                "field_4": "",
                "field_5": ""
            },
            {
                "id": "item-option-112",
                "field_1": "3.2",
                "field_2": "Customer Care Kit (VPN device or technical laptop kit + Remote assistance support for period of one year)",
                "field_3": 1,
                "field_4": "",
                "field_5": ""
            },
            {
                "id": "item-option-113",
                "field_1": "3.3",
                "field_2": "Disassembling, packing, crate and preparing for shipping",
                "field_3": 1,
                "field_4": "",
                "field_5": ""
            },
            {
                "id": "item-option-114",
                "field_1": "3.4",
                "field_2": "marko",
                "field_3": 1,
                "field_4": "",
                "field_5": ""
            }
        ]
    },

     {
        "id": "table--1",
        "noEdit": true,
        "element": "table",
        "text": "",
        "table_cols": 3,
        "col_1_width": 64,
        "col_2_width": 18,
        "col_3_width": 18,
        "rows": [
            {
                "id": "item--1",
                "field_1": {
                    "text": "COMPLETE SYSTEM GRAND TOTAL",
                    "style": {
                        "color": "white",
                        "backgroundColor": "#888888",
                        "fontWeight": "semibold",
                        "textAlign": "right"
                    },
                    "cssStyle": "color: white; background: #888888; font-weight: bold; text-align: right"
                },
                "field_2": "700.000 €",
                "field_3": ""
            },
            {
                "id": "item--2",
                "field_1": {
                    "text": "SPECIAL DISCOUNT APPROVED",
                    "style": {
                        "color": "white",
                        "backgroundColor": "#ED1C24",
                        "fontWeight": "semibold",
                        "textAlign": "right"
                    },
                    "cssStyle": "color: white; background: #ED1C24; font-weight: bold; text-align: right"
                },
                "field_2": "200.000 €",
                "field_3": "33%"
            },
            {
                "id": "item--3",
                "field_1": {
                    "text": "DISCOUNTED PRICE",
                    "style": {
                        "fontWeight": "semibold",
                        "textAlign": "right"
                    },
                    "cssStyle": "font-weight: bold; text-align: right"
                },
                "field_2": "500.000 €",
                "field_3": ""
            }
        ]
    },



  ]);

   useEffect(() => {

    const handleMessage = (event) => {
      const data = event.data;
      if(!data.contents) return;
      setData([]);
      setTimeout(() => {
          setData(data.contents);
      }, 1);
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);


  if(!data) {
    return <div></div>
  }

  return (
      <div style={{height: '100vh'}}>
          {data.length === 0
            ? ''
            : <Renderer data={data} />}

      </div>

  );
}

export default App;

